import { Component, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { ConfigProvider } from '../../providers/config/config';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { trigger, style, animate, transition } from '@angular/animations';
import { ProductsPage } from '../products/products';
import { NavController, Content,NavParams } from 'ionic-angular';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'page-home',
  animations: [
    trigger(
      'animate', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('700ms', style({ opacity: 0 }))
        ])
      ]
    )
  ],
  templateUrl: 'home.html',
})

export class HomePage {


  formData = {
    customers_email_address:'',
    customers_password:'',
  };

  @ViewChild(Content) content: Content;

  scrollToTop() {
    this.content.scrollToTop(700);
    this.scrollTopButton = false;
  }

  onScroll(e) {

    if (e.scrollTop >= 1200) this.scrollTopButton = true;
    if (e.scrollTop < 1200) this.scrollTopButton = false;
    //else this.scrollTopButton=false;
    //   console.log(e);
  }
  scrollTopButton = false;
  segments: any = 'topSeller';
  lead : any;
  constructor(
    public http: Http,
    public config: ConfigProvider,
    public shared: SharedDataProvider,
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    translate: TranslateService) {
    this.lead = navParams.get('lead');


  }


  openProducts(value) {
    this.navCtrl.push(ProductsPage, { sortOrder: value });
  }
  ngAfterContentChecked() {
    this.content.resize();
  }

  openCart() {
      this.navCtrl.push(CartPage);
  }
  openSearch() {
      this.navCtrl.push(SearchPage);
  }

  ionViewDidEnter()
  {
    this.storage.set('direction', 'ltr');
    console.log("Quote in Progress:",this.lead);
    if (this.lead != undefined){
      this.shared.orderDetails.delivery_lastname = this.lead.contact.lastName;
      this.shared.orderDetails.customers_telephone = this.lead.contact.phone;
      this.shared.orderDetails.delivery_postcode = this.lead.contact.postalCode;
      this.shared.orderDetails.customers_email_address = this.lead.contact.emailLowerCase;

    }


      console.log("Last Name:",this.shared.orderDetails.delivery_lastname);
    if(this.shared.orderDetails.delivery_lastname  != ""  ){
          swal({title: "Proceed with quote ?",text:
          "for " + this.shared.orderDetails.delivery_firstname + ' ' + this.shared.orderDetails.delivery_lastname ,icon: "success",buttons:
          ['No','Yes']}).then((willDelete) => {
          if (!willDelete) {
            this.shared.orderDetails.delivery_firstname = "";
            this.shared.orderDetails.delivery_lastname = "";
            this.shared.orderDetails.customers_telephone = "";
            this.shared.orderDetails.delivery_postcode = "";
            this.shared.orderDetails.customers_email_address = "";

          }

        })
          }
    console.log("Customer:",this.shared.customerData.ar_email_address);
    this.formData.customers_email_address = this.shared.customerData.ar_email_address;
    this.formData.customers_password = this.shared.customerData.customers_password;
    console.log("Check Login:",this.shared.customerData);
    this.http.post(this.config.url + 'processLogin', this.formData).map(res => res.json()).subscribe(data => {
      if (data.success == 1) {

        this.shared.login(data.data[0]);
        //console.log("After:",data.data[0]);

      }
      if (data.success == 0) {
        this.shared.logOut();
      }
    });

}
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts